import * as PIXI from "pixi.js";


const Bar = {
  width: 200,
  height: 30,
  radius: 5
}


export default class LoadingLayerFactory {
  static drawButton(button: PIXI.Graphics, percent: number){
    const barWidth = percent / 100 * Bar.width;
    button
      .clear() 
      .roundRect(-Bar.width / 2, -Bar.height / 2, Bar.width, Bar.height, Bar.radius)
      .fill(0xEFEFEF)
      .roundRect(-Bar.width / 2, -Bar.height / 2, barWidth, Bar.height, Bar.radius)
      .fill(0x21D4FE);
  }
  static setButtonTitle(buttonTitle: PIXI.Text) {
    buttonTitle.eventMode = "none";
    buttonTitle.style.fill = 0x0195b8;
    buttonTitle.style.fontSize = 20;
    buttonTitle.anchor.set(.5);
    buttonTitle.visible = false;
  }
}